import { FC, useMemo } from 'react';
import CardList from '../CardList';
import {
  CommonAttributesProps,
  ExtraAttributesPlanType,
  PlanTypeConnection,
} from 'screens/AccessExpressV3/accessExpress.types';

interface PlanTypeProps extends CommonAttributesProps {
  options: ExtraAttributesPlanType[];
  selected: ExtraAttributesPlanType | null;
  setSelected: (v: ExtraAttributesPlanType) => void;
}

const mapPlanTypeBody: Record<PlanTypeConnection, string> = {
  'INDIVIDUAL CONNECTION':
    'Data is allocated solely to this connection for dedicated use',
  'POOLED CONNECTION':
    'Shares data pool with other connections on the same plan',
  'FIXED WIRELESS':
    'High-bandwidth data plans for fixed wireless communication deployments',
};

const mapPlanTypeTitle: Record<PlanTypeConnection, string> = {
  'INDIVIDUAL CONNECTION': 'Individual connection',
  'POOLED CONNECTION': 'Pooled connection',
  'FIXED WIRELESS': 'Fixed wireless',
};

export const getPlanTypeTitle = (connectionType: PlanTypeConnection) => {
  return mapPlanTypeTitle[connectionType] ?? connectionType;
};

const PlanType: FC<PlanTypeProps> = ({
  handleStep,
  step,
  options,
  selected,
  setSelected,
}) => {
  const onSelect = (item: ExtraAttributesPlanType) => {
    handleStep && handleStep(step ?? 1);
    setSelected(item);
  };

  const _options = useMemo(
    () =>
      options.map((option) => ({
        ...option,
        id: option.connection_type,
        title: getPlanTypeTitle(option.connection_type),
        body: mapPlanTypeBody[option.connection_type] ?? option.connection_type,
        item: option,
      })),
    [options],
  );

  return (
    <>
      <CardList
        title="Plan type"
        selected={selected?.connection_type ?? null}
        onClick={(item) => onSelect(item as ExtraAttributesPlanType)}
        options={_options}
      />
    </>
  );
};

export default PlanType;
